<div soho-busyindicator
  [style.height]="'100%'"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="10000"
  [transparentOverlay]="true"
  [text]="' '"
  >

  <soho-accordion
    [allowOnePane]="false"
    [hasPanels]="true"
    [hasSubheaderSeparators]="true"
    (selected)="onSelected($event)"
    >
    @if (filterListTemplateData && filterListTemplateData.length > 0) {
      @for (data of filterListTemplateData; track data) {
        @if (!data.groupItems) {
          <soho-accordion-header #AccordionHeader [attr.data-index]="data.index" (drop)="onDrop($event)" (dragstart)="onDragStart($event)" (dragleave)="onDragLeave($event)" (dragover)="onDragOver($event)">
            <lm-list-card [listSpec]="listSpec" [dataView]="data.item" [boldFirstRow]="false"></lm-list-card>
          </soho-accordion-header>
        } @else {
          <soho-accordion-header>
            {{data.item}}
          </soho-accordion-header>
          <soho-accordion-pane>
            @for (groupItem of data.groupItems; track groupItem) {
              <soho-accordion-header #AccordionHeader [attr.data-index]="groupItem.index" (drop)="onDrop($event)" (dragstart)="onDragStart($event)" (dragleave)="onDragLeave($event)" (dragover)="onDragOver($event)">
                <lm-list-card [listSpec]="listSpec" [dataView]="groupItem.item" [boldFirstRow]="false"></lm-list-card>
              </soho-accordion-header>
            }
          </soho-accordion-pane>
        }
      }
    } @else {
      <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
    }
  </soho-accordion>


</div>

<div #dialogPlaceholder id="lmFilterListDialogPlaceholder" class="lmDialogPlaceholder"></div>
